// extracted by mini-css-extract-plugin
module.exports = {"basicFont":"attendancestyles_basicFont__Om0KR","select":"attendancestyles_select__22T6q","active":"attendancestyles_active__1EdlU"};